import { apiRequest } from './client';

export function searchWorkspace(token, query) {
  const q = String(query || '').trim();
  const params = new URLSearchParams({ q });
  return apiRequest(`/admin/search?${params}`, token);
}
